import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './HeroSection.css';
import osProfile from '../assets/os-profile.jpg';

const HeroSection = () => {
  const { t } = useTranslation();

  useEffect(() => {
  // Run after full paint so all .reveal elements exist
  requestAnimationFrame(() => {
    const items = document.querySelectorAll('.reveal');
    if (!items.length) return;

    // Fallback if IntersectionObserver unsupported
    if (!('IntersectionObserver' in window)) {
      items.forEach(el => el.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { root: null, rootMargin: '0px', threshold: 0.1 });

    items.forEach(el => io.observe(el));
  });
}, []);



  return (
    <>
      {/* ===== HERO ===== */}
      <section className="hero container-fluid">
        <h1 className="hero__headline reveal">
          <span className="hero__line">
            {t('hero-section.drivenby')} <span className="nowrap"><span className="keyword keyword--passion">{t('hero-section.passion')}</span>.</span>
          </span>
          <span className="hero__line">
            {t('hero-section.perfectedby')} <span className="nowrap"><span className="keyword keyword--technique">{t('hero-section.technique')}</span>.</span>
          </span>
        </h1>

        <p className="hero__intro reveal delay-1">
          {t('hero-section.paragraph')}
        </p>

        <div className="hero__footer">
          <div className="hero__socials reveal delay-2">
            <a href="https://www.instagram.com/ondrejstaidl/" target="_blank" rel="noopener noreferrer">
              <svg className="icon link-arrow" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 2L12 22M12 22L5 15M12 22L19 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Instagram
            </a>
            <a href="https://www.youtube.com/@ondrejstaidl" target="_blank" rel="noopener noreferrer">
              <svg className="icon link-arrow" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 2L12 22M12 22L5 15M12 22L19 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              YouTube
            </a>
            <a href="https://www.linkedin.com/in/ondrej-staidl-3642b7ba/" target="_blank" rel="noopener noreferrer">
              <svg className="icon link-arrow" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 2L12 22M12 22L5 15M12 22L19 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              LinkedIn
            </a>
            <a href="https://herohero.co/ondrejstaidl" target="_blank" rel="noopener noreferrer">
              <svg className="icon link-arrow" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 2L12 22M12 22L5 15M12 22L19 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Herohero
            </a>
          </div>

          <button
            className="cta reveal delay-3"
            onClick={() => {
              const el = document.getElementById('contact');
              if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }}
          >
            <svg className="icon cta-arrow" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M12 2L12 22M12 22L5 15M12 22L19 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            {t('hero-section.cta-button')}
          </button>
        </div>
      </section>

      {/* ===== ABOUT (photo + text) ===== */}
      <section className="about container">
        <div className="about__grid">
          <img
            src={osProfile}
            alt={t('hero-section.whoiam.title')}
            className="about__photo reveal"
          />

          <div className="about__copy">
            <h2 className="about__title reveal delay-1">
              {t('hero-section.whoiam.title')}
            </h2>
            <p className="about__text reveal delay-2">
              {t('hero-section.whoiam.description')}
            </p>
            <p className="about__text about__muted reveal delay-3">
              {t('hero-section.whoiam.details')}
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
